import * as React from 'react';
import {
	FILE_NAME,
	PLACEHOLDERS_COPY
} from '@sonar-software/sonar-ts-constants';
import { Form, Input } from 'antd';

const { MAX: max, MESSAGE: message } = FILE_NAME;

export interface FileInputProps {
	disabled?: boolean;
}

export const FileInput: React.FC<FileInputProps> = ({ disabled }) =>
	<Form.Item
		name='name'
		rules={ [
			{
				max,
				message
			}
		] }>
		<Input
			autoFocus
			disabled={ disabled }
			placeholder={ PLACEHOLDERS_COPY.FILE_NAME }
			type='text' />
	</Form.Item>;

